import { Link } from 'react-router-dom';
import LinkItem from 'components/common/Link';
import ROUTES from 'constants/routes';

const LocationNav = ({ upperText, lowerText }) => {
    return (
        <Link to={ROUTES.location} className="locations-navitem">
            <div className="button-text">{upperText}</div>
            <LinkItem text={lowerText} />
        </Link>
    );
};

export default LocationNav;
